import { render, staticRenderFns } from "./SidebarNotificationsHrLawyer.vue?vue&type=template&id=7c799ae8&"
import script from "./SidebarNotificationsHrLawyer.vue?vue&type=script&lang=js&"
export * from "./SidebarNotificationsHrLawyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports